import { Currency, iAuthInfoLocalStorage, ProductTypes, ServiceTypes } from '@/types';

const PENDING_PRODUCT_STORE_KEY = 'pendingProduct';
const AUTH_INFO_STORE_KEY = 'authInfo';
const USER_CURRENCY_STORE_KEY = 'userCurrency';
const RESIGNATION_VIEWED_STORE_KEY = 'resignationViewed';
const ORIGIN_STORE_KEY = 'origin';

const storage = {
  clear: () => {
    window.localStorage.clear();
  },

  getToken: () => {
    const authInfoRawData: string | null = window.localStorage.getItem(AUTH_INFO_STORE_KEY);
    return authInfoRawData ? JSON.parse(authInfoRawData).access_token : null;
  },

  getCompanyId: () => {
    const authInfoRawData: string | null = window.localStorage.getItem(AUTH_INFO_STORE_KEY);
    return authInfoRawData ? JSON.parse(authInfoRawData).company_id : null;
  },

  setToken: (token: string) => {
    const authInfoRawData: string | null = window.localStorage.getItem(AUTH_INFO_STORE_KEY);
    if (authInfoRawData) {
      const authInfo: iAuthInfoLocalStorage = JSON.parse(authInfoRawData);
      authInfo.access_token = token;
      window.localStorage.setItem(AUTH_INFO_STORE_KEY, JSON.stringify(authInfo));
    }
  },

  getPendingProduct: (): ProductTypes | null => {
    const product = window.localStorage.getItem(PENDING_PRODUCT_STORE_KEY);
    return product ? JSON.parse(product) : null;
  },

  setPendingProduct: (product: ProductTypes) => {
    window.localStorage.setItem(PENDING_PRODUCT_STORE_KEY, JSON.stringify(product));
  },

  clearPendingProduct: () => {
    window.localStorage.removeItem(PENDING_PRODUCT_STORE_KEY);
  },

  clearUserData: () => {
    storage.clearPendingProduct();
    storage.clearUserCurrency();
  },

  getUserCurrency: (): Currency | null => {
    const userCurrency = window.localStorage.getItem(USER_CURRENCY_STORE_KEY);

    return userCurrency ? JSON.parse(userCurrency) : null;
  },

  setUserCurrency: (userCurrency: Currency) => {
    window.localStorage.setItem(USER_CURRENCY_STORE_KEY, JSON.stringify(userCurrency));
  },

  clearUserCurrency: () => {
    window.localStorage.removeItem(USER_CURRENCY_STORE_KEY);
  },

  setResignationViewed: () => {
    window.localStorage.setItem(RESIGNATION_VIEWED_STORE_KEY, 'true');
  },

  getResignationViewed: (): boolean =>
    window.localStorage.getItem(RESIGNATION_VIEWED_STORE_KEY) === 'true' || false,

  clearResignationViewed: () => {
    window.localStorage.removeItem(RESIGNATION_VIEWED_STORE_KEY);
  },

  setExternalOrigin: (origin: string | null) => {
    if (origin != storage.getExternalOrigin() && origin != null) {
      window.localStorage.setItem(ORIGIN_STORE_KEY, origin);
    }
  },

  getExternalOrigin: (): string | null => window.localStorage.getItem(ORIGIN_STORE_KEY) || null,

  setSidebarServices: (groupId: string, userId: string, services: ServiceTypes[]) => {
    window.localStorage.setItem('my-services-' + groupId + '-' + userId, JSON.stringify(services));
  },
};

export default storage;
